const ENTITY_MAP: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;',
    '/': '&#x2F;'
};

function toSafeString(value: unknown): string {
    if (typeof value === 'string') {
        return value;
    }
    if (value === null) {
        return 'null';
    }
    if (value === undefined) {
        return 'undefined';
    }
    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
        return String(value);
    }
    return '';
}

export function escapeHtmlString(value: unknown): string {
    return toSafeString(value).replace(/[&<>"'/]/g, (s): string => ENTITY_MAP[s]);
}

/**
 * Decodes HTML entities (e.g. &#8805;, &gt;) to their Unicode characters.
 * Safe for display in text interpolation after HTML sanitization.
 */
export function decodeHtmlEntities(value: string): string {
    if (!value) {
        return '';
    }
    if (typeof document === 'undefined') {
        return value;
    }
    const textarea: HTMLTextAreaElement = document.createElement('textarea');
    let decoded: string = value;
    for (let pass: number = 0; pass < 3; pass++) {
        textarea.innerHTML = decoded;
        const next: string = textarea.value;
        if (next === decoded) {
            break;
        }
        decoded = next;
    }
    return decoded;
}
